var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStudentAnalysis(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "92px",
    height: "91px",
    viewBox: "0 0 92 91",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(0.5 0.5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.5 0C28.7752 0 37 9.06342 37 20.125C37 21.7128 35.7257 23 34.1538 23C32.582 23 31.3077 21.7128 31.3077 20.125C31.3077 12.1328 25.5155 5.75 18.5 5.75C11.4845 5.75 5.69231 12.1328 5.69231 20.125C5.69231 21.7128 4.41804 23 2.84615 23C1.27427 23 0 21.7128 0 20.125C0 9.06342 8.22478 0 18.5 0Z",
    transform: "translate(23 36)",
    id: "Path",
    fill: "#0B67B2",
    stroke: "none",
    className: "fill-secondary-color"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20C15.5228 20 20 15.5228 20 10C20 4.47715 15.5228 0 10 0ZM10 5.71429C12.3669 5.71429 14.2857 7.63307 14.2857 10C14.2857 12.3669 12.3669 14.2857 10 14.2857C7.63307 14.2857 5.71429 12.3669 5.71429 10C5.71429 7.63307 7.63307 5.71429 10 5.71429Z",
    transform: "translate(31 22)",
    id: "Oval",
    fill: "#0B67B2",
    stroke: "none",
    className: "fill-secondary-color"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.4703 0C40.3906 0 52.4859 11.9624 52.4859 26.7188C52.4859 41.4751 40.3906 53.4375 25.4703 53.4375C14.1309 53.4375 4.11772 46.4638 0.183551 36.1419C-0.370432 34.6884 0.371832 33.066 1.84144 32.5181C3.31106 31.9702 4.95151 32.7043 5.50549 34.1578C8.61128 42.3063 16.5173 47.8125 25.4703 47.8125C37.2495 47.8125 46.7984 38.3685 46.7984 26.7188C46.7984 15.069 37.2495 5.625 25.4703 5.625C17.5075 5.625 10.325 9.97647 6.64136 16.8008C5.90171 18.171 4.17894 18.6888 2.79346 17.9573C1.40797 17.2258 0.884414 15.522 1.62406 14.1517C6.28703 5.51317 15.387 0 25.4703 0Z",
    transform: "matrix(-0.7071067 0.7071068 0.7071068 0.7071067 40.244186 0.804966)",
    id: "Path",
    fill: "#07A5DF",
    stroke: "none",
    className: "fill-primary-color"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0L91 0L91 90L0 90L0 0Z",
    id: "Rectangle",
    fill: "none",
    fillRule: "evenodd",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.26563 0C6.48289 0 8.30503 1.67312 8.51172 3.81246L8.53125 4.21875L8.53125 29.5313C8.53125 31.8612 6.62146 33.75 4.26563 33.75C2.04836 33.75 0.226224 32.0769 0.0195268 29.9375L0 29.5313L0 4.21875C0 1.8888 1.90979 0 4.26563 0Z",
    transform: "matrix(-0.7071067 0.7071068 0.7071068 0.7071067 59.227097 50.890232)",
    id: "Path-17",
    fill: "#07A5DF",
    stroke: "none",
    className: "fill-primary-color"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStudentAnalysis);
export default __webpack_public_path__ + "static/media/studentAnalysis.8953be41e8e79575f99561b125bfd8ee.svg";
export { ForwardRef as ReactComponent };